import React from 'react'
import { createUseStyles } from 'react-jss'

import View from '../form/View'

const logo = require('../../assets/logo.png')
const useStyles = createUseStyles(theme => ({
  content: {
    justifyContent: 'space-between',
    flexDirection: 'column',
    overflowX: 'hidden',
    padding: '32px',
    
    '@media(min-width: 500px)': {
      background: '#ffffff',
      position: 'relative',
      width: '100%',
      maxWidth: '400px',
      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
      borderRadius: '16px',
      zIndex: 10,
    }
  },
  logo: {
    alignItems: 'center',
    justifyContent: 'center',
    margin: '14px 0'
  },
  logoImg: {
    width: '60%',
    objectFit: 'contain'
  },
  title: {   
    justifyContent: 'center',
    textAlign: 'center',
    fontFamily: 'Fira Sans, sans serif',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '32px',
    color: '#DD3416',
    margin: '14px 0',
  }, 
  message: {
    margin: '14px 0',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '18px',
    color: '#454545'
  },
  link: {
    cursor: 'pointer',
    textDecoration: 'underline',
    color: theme.colors.secondary
  }
}))

function SignupFailed () {
  const styles = useStyles()
 
  const reload = () => {
    document.location.reload(true)
  }

  return (
    <View className={styles.content}>
      <View className={styles.logo}>
        <img src={logo} alt="Logo" className={styles.logoImg} />
      </View>
      <View className={styles.title}>
        Ocorreu um erro =(
      </View>
      <View className={styles.message}>    
        Não foi possível completar o cadastro. Verifique a sua conexão e tente novamente.
      </View>

      <View onClick={reload} className={`${styles.message} ${styles.link}`}>    
        Clique aqui para tentar novamente
      </View>
    </View>
  )
}

export default SignupFailed